import { ServiceProviderDate } from "@/models/service-provider-date.model"
import { type IServiceProviderDate } from "@/interfaces/api/service-provider-date.interface"
import { ServiceProviderDateRepository } from "@/repositories/service-provider-date-repository"
import { useServiceProviderDateStore } from "@/store/service-provider-date.store"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"

export class ServiceProviderDateController extends GenericModelController<
  ServiceProviderDate,
  IServiceProviderDate,
  ServiceProviderDateRepository
> {
  constructor() {
    const { addServiceProviderDateToDict } = useServiceProviderDateStore()

    super(
      ServiceProviderDate,
      { onCreate: addServiceProviderDateToDict },
      new ServiceProviderDateRepository()
    )
  }
}
